export default __webpack_public_path__ + "static/parigi-plus-4-901ecb3063c5fde26c9b7f60e782c7ae.jpg";